
import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { RunnitsOwnerSelection } from '@/store';
import { RUNNITS_OWNER_SELECTION } from '@/views/Runnits/constants';
import ComplexBackground from '@/components/designElements/ComplexBackground.vue';
import RunnitsOwnerSelectionPicker from '@/views/Runnits/RunnitsOwnerSelectionPicker/RunnitsOwnerSelectionPicker.vue';
import AccountSelectionMenuOrBottomSheet from '@/components/AccountSelectionMenuOrBottomSheet.vue';
import RunnitAccountSelectionButton from './RunnitAccountSelectionButton.vue';
import { TeamUserMixin } from '@/mixins';

export default Vue.extend({
	name: 'RunnitAccountSelectionDialog',
	mixins: [
		TeamUserMixin,
	],
	props: {
		isSideNavDesignExpanded: { type: Boolean, default: false },
		isSideNavDesignCollapsed: { type: Boolean, default: false },
		useMenuOrBottomSheet: { type: Boolean, default: false },
	},
	data () {
		return {
			accountSelectionDialogOpen: false,
			accountSelectionMenuOpen: false,
		};
	},
	computed: {
		...mapState([
			'loadingTeam',
			'loadingUser',
			'team',
			'runnitState',
		]),
		...mapGetters([
			'displayLabels',
		]),
		isRunnitsOwnerSelectionLoading () {
			if (this.runnitState.runnitsOwnerSelection === RUNNITS_OWNER_SELECTION.TEAM) {
				return !!this.loadingTeam;
			}
			return !!this.loadingUser;
		},
		runnitsOwnerSelectionTooltipHtml () {
			let label: string = '';

			if (this.runnitState.runnitsOwnerSelection === RUNNITS_OWNER_SELECTION.USER) {
				label = `<span style="color: var(--grey-200)">Selected account</span><br><b>Personal</b>`;
			} else if (this.runnitState.runnitsOwnerSelection === RUNNITS_OWNER_SELECTION.TEAM) {
				label = `<span style="color: var(--grey-200)">Selected account</span><br><b>${this.displayLabels.team} (${this.team ? this.team.name : `No ${this.displayLabels.team} selected`})</b>`;
			}

			return label;
		},
	},
	watch: {
		'$store.state.triggers.openRunnitAccountSelectionMenuTrigger' (newVal: number, oldVal: number) {
			if (!this.useMenuOrBottomSheet) {
				return;
			}
			if (newVal > 0 && newVal !== oldVal) {
				this.$nextTick(() => {
					this.accountSelectionMenuOpen = true;
				});
			}
		},
	},
	methods: {
		...mapActions([
			'updateRunnitState',
		]),
		onOpenAccountSelectionDialog () {
			if (this.isRunnitsOwnerSelectionLoading) return;
			this.accountSelectionDialogOpen = true;
		},
		onRunnitsOwnerSelectionChange (runnitsOwnerSelection: RunnitsOwnerSelection) {
			this.switchBetweenTeamAndUser(runnitsOwnerSelection);
			this.accountSelectionDialogOpen = false;
		},
	},
	components: {
		ComplexBackground,
		RunnitsOwnerSelectionPicker,
		AccountSelectionMenuOrBottomSheet,
		RunnitAccountSelectionButton,
	},
});
